<template>
  <div>
    <a-modal
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      v-model="showModal"
      title="Remove User"
      @ok="() => (showModal = false)"
    >
      <template slot="footer">
        <button
          key="cancel"
          @click="showModal = false"
          :style="{
            background: '#fff',
            color: getPrimaryColor(),
            padding: '10px 40px',
            'border-radius': '8px',
            border: '1px solid ' + getPrimaryColor(),
          }"
        >
          Cancel
        </button>
        <a-button
          key="submit"
          type="primary"
          @click="removeUserFromCircle()"
          class="primary-button"
          :style="{
            border: '1px solid ' + getPrimaryColor(),
            background: getPrimaryColor(),
            padding: '10px 40px',
            'border-radius': '8px'
          }"
        >
          Remove
        </a-button>
      </template>
      <p
        v-if="user"
        :style="{
          'font-size': '16px'
        }"
      >
        Do you want to remove {{ user.display_name }} ?
      </p>
    </a-modal>
  </div>
</template>

<script>
// import { eventBus } from '../../main'
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("user");

export default {
  name: "ReportContent",
  data() {
    return {
      showModal: false,
      user: null
    };
  },
  methods: {
    show(data) {
      this.showModal = true;
      this.user = data;
    },
    hide() {
      this.showModal = false;
    },
    /**
     * Remove User form Circle
     */
    removeUserFromCircle() {
      UserRepository.removeFromCircle(this.user, this.currentCircle.id)
        .then(res => {
          this.displayDots = false;
          this.$emit("hideDots");
          this.hide();
          this.$notification.success({
            message: "Success",
            description: "User is removed from the circle."
          });
        })
        .catch(err => {
          this.displayDots = false;
          this.$emit("hideDots");
          this.hide();
          this.$notification.error({
            message: "Error",
            description:
              "User is not present in your circle. Please try adding it."
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Modals/RemoveUser.vue